export default __webpack_public_path__ + "static/media/cancel.46c82ed8.svg";